export default "__VITE_ASSET__CgI9Hu5H__"